var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Stack, ThemeProvider, Typography, useMediaQuery } from '@mui/material';
import theme from '../theme_v2';
import SearchBar from './SearchBar';
var SectionHeaderActions;
(function (SectionHeaderActions) {
    SectionHeaderActions["SEARCH"] = "search";
})(SectionHeaderActions || (SectionHeaderActions = {}));
var SectionHeader = function (_a) {
    var title = _a.title, description = _a.description, actions = _a.actions, onSearch = _a.onSearch, startIcon = _a.startIcon, _b = _a.variant, variant = _b === void 0 ? 'h5' : _b, sx = _a.sx;
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var isDescriptionHtml = description && description.includes('<');
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsxs(Stack, __assign({ my: 2, direction: isMobile ? 'column' : 'row', alignItems: isMobile ? 'stretch' : 'center', justifyContent: 'space-between', spacing: 2, sx: sx }, { children: [_jsxs(Stack, __assign({ direction: 'row', spacing: 2, alignItems: 'center', flex: 1 }, { children: [startIcon, _jsxs(Stack, __assign({ direction: 'column', spacing: 1, alignItems: 'flex-start', textAlign: 'left', sx: { '& p': { m: 0 } } }, { children: [_jsx(Typography, __assign({ variant: variant, fontWeight: 'bold' }, { children: title })), description && !isDescriptionHtml && _jsx(Typography, __assign({ variant: 'body2', color: 'secondary' }, { children: description })), description && isDescriptionHtml && _jsx("div", { dangerouslySetInnerHTML: { __html: description } })] }))] })), _jsx(Stack, __assign({ direction: isMobile ? 'column' : 'row', spacing: 2 }, { children: actions === null || actions === void 0 ? void 0 : actions.map(function (action, index) {
                        if (action === SectionHeaderActions.SEARCH) {
                            return _jsx(SearchBar, { onSearch: onSearch, width: isMobile ? '100%' : undefined }, SectionHeaderActions.SEARCH);
                        }
                        return _jsx(React.Fragment, { children: action }, index);
                    }) }))] })) })));
};
export default SectionHeader;
